import { NotFound, PageSpinner } from '@ohpen/enso-ui';
import { useApiClient, useAuth, type UseApiClientOptions } from '@ohpen/react-auth';
import { useConfig, type IApp } from '@ohpen/react-utils';

import * as configSdk from '@config/api';
import { PortalHost } from './PortalHost';

export const AuthenticatedContent = () => {
  const config = useConfig<IApp>();
  const auth = useAuth();

  const apiClientOptions: UseApiClientOptions = {
    config,
    version: config.VERSION,
    baseUrl: config?.APP?.apiBaseurl ?? '',
    client: configSdk.client,
    sdkModule: configSdk,
    getAccessToken: auth.getAccessToken,
  };

  const { isReady, error } = useApiClient(apiClientOptions);

  if (!isReady) return <PageSpinner />;

  if (error) return <NotFound />;

  return <PortalHost />;
};
